// extracted by mini-css-extract-plugin
export default {"loader":"styles_loader__-uEvY","centered":"styles_centered__-lssF"};